const Rengiamas = 'filling'
const LaukiaApmokejimo = 'waiting-for-payment'
const Uzsakytas = 'ordered'
const Apmoketas = 'payed'
const Patvirtintas = 'provided'
const Atmestas = 'rejected'
const Isduotas = 'done'

export default {
    RENGIAMAS: Rengiamas,
    UZSAKYTAS: Uzsakytas,
    ATMESTAS: Atmestas, 
    LAUKIA_APMOKEJIMO: LaukiaApmokejimo,
    PATVIRTINTAS: Patvirtintas,
    APMOKETAS: Apmoketas,
    ISDUOTAS: Isduotas,
}